import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillInstagram } from "react-icons/ai";
import { BsTwitterX } from "react-icons/bs";
import { FaDiscord } from "react-icons/fa";
import { SiPatreon } from "react-icons/si";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="12" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://x.com/Chonkbox"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <BsTwitterX />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/Chonkbox"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://discord.gg/t4U6mkK5wC"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaDiscord />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://patreon.com/chonkbox"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <SiPatreon />
              </a>
            </li>
          </ul>
        </Col>
        <Col md="12" className="footer-copywright">
          Copyright © {year} Chonkbox Studios
        </Col>
        <Col md="12" className="footer-credit">
          Site design forked from <a href='https://github.com/soumyajit4419/Portfolio'>Soumyajit4419</a>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
